'use client'
import React, { useState } from 'react'
import Link from 'next/link'
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Input } from "@heroui/react"

import { formatDate } from '../src/formatter'
import { inputStyle } from '../src/styles'

const JoinButton = ({ user, challenge, joinFn, clearError, passThroughCode }) => {
  const [enableButton, setEnableButton] = useState((user && user.id && Boolean(challenge.code) && passThroughCode !== challenge.code) ? false : true)
  const [code, setCode] = useState(passThroughCode || '')
  const [joining, setJoining] = useState()

  let trimmed = challenge.challengeName.replace(/^the /i, '').replace(/ challenge$/i, '')
  if (challenge.group.type === 'team' || challenge.group.teamClone) {
    trimmed = challenge.challengeName.replace(/^the /i, '').replace(/ team$/i, '')
  }

  const modal = useDisclosure()
  
  const submit = (e) => {
    e.preventDefault()
    modal.onOpen()
  }
  
  const joinChallenge = async () => {
    setEnableButton(false)
    setJoining(true)
    modal.onClose()
    joinFn(code)
  }

  // backup check to hide button if state has changed
  // happened after join sometimes and button would hang around
  if (user.challengesJoined && user.challengesJoined.find(c => { return c.id === challenge.id && (c.joined || c.whitelisted) })) return <></>

  const eventDislaimer = () => {
    if (challenge.group.type === 'event') {
      return <div style={{ marginTop: '10px', textAlign: 'center', color: '#999', fontSize: '14px' }}>Join ALL events in: <Link href={`/group/[id]`} as={`/group/${challenge.childGroupId}`}>{challenge.group.name}</Link></div>;
    }
  }

  return <form name='form'
    role='form'
    noValidate
    onSubmit={submit} >
      
      {challenge.code && <>
        <div className='flex flex-col items-center'>
          <Input
            type='text'
            label='Enter Code to Join'
            name='code'
            maxLength={36}
            value={code}
            size='lg'
            radius='sm'
            className='mb-2'
            classNames={ inputStyle }
            onChange={(e) => {
              clearError()
              setCode(e.target.value)
              if (e.target.value && e.target.value.toLowerCase() === challenge.code.toLowerCase()) {
                setEnableButton(true)
              } else {
                setEnableButton(false)
              }
            }} />
        
          <Button
            color='primary'
            size='lg'
            type='submit'
            isDisabled={!enableButton}>
              {(joining ? `JOINING ${challenge.group.type.toUpperCase()} ... ` : `JOIN ${challenge.group.type.toUpperCase()}`)}
          </Button>
        </div>  
        {eventDislaimer()}
      </>}  
          
      {!challenge.code && <div className='flex flex-col items-center'>
        <Button
          color='primary'
          size='lg'
          type='submit'
          isDisabled={!enableButton}>
            {joining ? `JOINING ${challenge.group.type.toUpperCase()} ... ` : `JOIN ${challenge.group.type === 'event' ? challenge.group.name.toUpperCase() : challenge.group.type.toUpperCase()}`}
        </Button>
        {eventDislaimer()}
      </div>}
      
      {challenge.joinDeadline && <div className='text-gray-400 mt-2'>Deadline to join: {formatDate(challenge.joinDeadline, true)}</div>}
      
      <Modal isOpen={modal.isOpen} onOpenChange={modal.onOpenChange}>
        <ModalContent>
          <ModalHeader className="flex flex-col gap-1">Commitment Time</ModalHeader>
          <ModalBody className='inline'>
            {challenge.group.type === 'event' ? 
              <span>Are you sure you want to join the <b>{challenge.group.name}</b> {challenge.group.type}?</span> :
              <span>Are you sure you want to join the <b>{trimmed}</b> {challenge.group.type}?</span>
            }
          </ModalBody>
          <ModalFooter>
            <Button color="danger" variant="light" onPress={modal.onClose}>
              Cancel
            </Button>
            <Button color="primary" onPress={joinChallenge}>
              Yes, Join
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      
  </form>
}

export default JoinButton